import React, { useState } from 'react';
import { 
  ComputerDesktopIcon, 
  CameraIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';
import { AnimatedSoftwareCard } from './AnimatedSoftwareCard';

export const InteractiveProductsSection = () => {
  const [activeProduct, setActiveProduct] = useState(null);

  const products = [
    {
      id: 1,
      name: "DICOMFiles",
      tagline: "Automatización Completa del Flujo DICOM",
      description: "Sistema avanzado que reduce el trabajo manual en un 80-90% y elimina errores humanos en la conversión de documentos DICOM. Procesamiento 24/7 sin intervención humana.",
      icon: <ComputerDesktopIcon className="h-8 w-8" />,
      features: [
        "Procesamiento 24/7 sin intervención humana",
        "Integración transparente con sistemas PACS",
        "Gestión inteligente de worklist DICOM",
        "Procesamiento automático de PDFs",
        "Sistema de códigos QR integrado"
      ],
      link: "/dicomfiles",
      cta: "Conocer DICOMFiles",
      gradient: "from-blue-500 to-blue-700",
      accentColor: "blue",
      isPopular: true
    },
    {
      id: 2,
      name: "DICOMCapture",
      tagline: "Captura y Procesamiento Avanzado",
      description: "Herramienta especializada para la captura y procesamiento de imágenes DICOM desde equipos médicos con validación automática de calidad y control de flujo de trabajo.",
      icon: <CameraIcon className="h-8 w-8" />,
      features: [
        "Captura desde equipos médicos",
        "Validación automática de calidad",
        "Procesamiento en tiempo real",
        "Integración con sistemas PACS",
        "Control de flujo de trabajo"
      ],
      link: "/contact",
      cta: "Más Información",
      gradient: "from-green-500 to-green-700",
      accentColor: "green",
      isPopular: false
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-blue-200 rounded-full opacity-20 animate-pulse" />
        <div className="absolute bottom-20 right-10 w-24 h-24 bg-green-200 rounded-full opacity-20 animate-pulse" style={{ animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-purple-200 rounded-full opacity-20 animate-pulse" style={{ animationDelay: '2s' }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-4">
            <SparklesIcon className="h-4 w-4 mr-2" />
            Nuestros Productos
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Soluciones DICOM
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-600">
              Profesionales
            </span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Descubre nuestras herramientas especializadas diseñadas para optimizar 
            el flujo de trabajo DICOM en centros médicos modernos.
          </p>

          {/* Interactive Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 mb-2">80-90%</div>
              <div className="text-gray-600">Reducción trabajo manual</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-600 mb-2">24/7</div>
              <div className="text-gray-600">Procesamiento automático</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-600 mb-2">100%</div>
              <div className="text-gray-600">Cumplimiento DICOM</div>
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {products.map((product) => (
            <AnimatedSoftwareCard
              key={product.id}
              name={product.name}
              tagline={product.tagline}
              description={product.description}
              features={product.features}
              link={product.link}
              cta={product.cta}
              icon={product.icon}
              gradient={product.gradient}
              accentColor={product.accentColor}
              isPopular={product.isPopular}
            />
          ))}
        </div>

      </div>
    </section>
  );
};
